import dynamic from 'next/dynamic'
import Image from 'next/image'
import Router from 'next/router'
const Skeleton = dynamic(() => import('@mui/material/Skeleton'))

const FeaturedNFt = ({featured}: any) => {
  if (!featured) {
    return <Skeleton
        animation="wave"
        variant="rectangular"
        height={320}
        className="col-span-2 h-36 bg-gray-400/20 md:h-48"
      />
  }
  return (
    <div className="col-span-2 flex h-full w-full  items-center  justify-center">
      <Image
        src={featured?.thumbnail}
        className="bg-grayTransparent object-fill hover:cursor-pointer"
        width={1200}
        height={360}
        id="features_image"
        blurDataURL="/images/placeholder.png"
        placeholder="blur"
        alt="thumbnail"
        onClick={() => {
          Router.push(`/categories/${featured.category}/${featured?.asset_id}`)
        }}
      />
    </div>
  )
}

export default FeaturedNFt
